// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"bed9e99c","329":"fc21ed95","423":"741d21f0","626":"bdedb85a","692":"4824a4fb","732":"930be875","767":"81fd1c7b","835":"28c2218c","911":"c058e7ba"}[chunkId] + ".chunk.js";
};